import styles from './Rodape.css'

export default function Footer() {
    return (
        <footer>

            <div className='fixar-rodape d-flex justify-content-center align-items-center div-end'>
                <span>© 2023, made by  </span>
                <a href="https://viniciusduarte.vercel.app/" target="_blank">Vinicius Duarte</a>
            </div>

        </footer >
    )
}
